module.exports = __webpack_public_path__ + "img/Detection_Line_16px_Icon_light.bce7d14c.svg";